import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import Toggle from 'react-toggle'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'

class OffersList extends React.Component {
  state = {
    offersListData: [],
    openDailog: false,
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
  }

  componentDidMount() {
    this.offerList()
  }

  offerList = async () => {
    this.setState({
      open: true,
    })

    await axios
      .get(Constant.getAPI() + `/offers/list-offers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          keyword: this.state.keyword,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            offersListData: res.data.data,
            open: false,
            disabled: res.data?.pagination?.next ? false : true,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          open: false,
        })
      })
  }

  deleteOffer = (id) => {
    Swal.fire({
      title: 'Are you sure to delete this Offer?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var token = `Bearer ${localStorage.getItem('loged_In_auth')}`
        const data = {
          id: id,
          is_deleted: true,
        }
        await axios
          .put(Constant.getAPI() + `/offers/update-offer-status`, data, {
            headers: {
              Authorization: token,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              toast: true,
              icon: 'success',
              position: 'top-end',
              title: 'Deleted Successfully!',
              showConfirmButton: false,
              timerProgressBar: true,
              timer: 2500,
            })
            this.offerList()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.offerList()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.offerList()
      }
    )
  }

  handleStatusChange = async (id, status, type) => {
    let data = { id }

    if (type == 'show_title_on_header') {
      data.show_title_on_header = status
    } else {
      data.is_active = status
    }

    await axios
      .put(Constant.getAPI() + '/offers/update-offer-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.offerList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  // onPushClick = async (id) => {
  //   Swal.fire({
  //     title: 'Are you sure to send the notification regarding this item?',
  //     showDenyButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: `Yes`,
  //     denyButtonText: `No`,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       await axios
  //         .post(
  //           Constant.getAPI() + '/admin/send-pushwoosh',
  //           {
  //             type: 'FO',
  //             target_id: id,
  //             selected_country: localStorage.getItem('countryShortName') || 'KWT',
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
  //               country_short_name: `${localStorage.getItem('countryShortName')}`,
  //             },
  //           }
  //         )
  //         .then((res) => {
  //           if (res.status === 200) {
  //             Swal.fire('Notification Sent !', '', 'success')
  //           }
  //         })
  //         .catch((err) => {
  //           if (err?.response?.status === 401) {
  //             Constant.getAuthLogout()
  //           } else {
  //             Swal.fire({
  //               title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
  //               icon: 'error',
  //               text: '',
  //               type: 'error',
  //               confirmButtonColor: '#3085d6',
  //               cancelButtonColor: '#d33',
  //               confirmButtonText: 'Ok',
  //             })
  //           }
  //         })
  //     }
  //   })
  // }

  render() {
    const columns = [
      {
        name: 'img_en',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (image_path) => {
            return (
              <div>
                <img
                  src={
                    image_path !== undefined && image_path !== null && image_path !== {}
                      ? Constant.getImage() + image_path
                      : './assets/images/icon.png'
                  }
                  className="img-fluid img-40"
                  alt="tbl"
                />
              </div>
            )
          },
        },
      },
      {
        name: 'title_en',
        label: 'Title : English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'title_ar',
        label: 'Title: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'show_title_on_header',
        label: 'Show title on header',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isActive}
                  value={isActive + ''}
                  onChange={this.handleStatusChange.bind(this, id, !isActive, 'show_title_on_header')}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isActive}
                  value={isActive + ''}
                  onChange={this.handleStatusChange.bind(this, id, !isActive)}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex align-items-center">
                <ActivitiesController refId={id}>Activities</ActivitiesController>
                <Link
                  to={`/offers-category/` + id}
                  className="m-r-15 m-l-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Offers Category"
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
                <Link
                  to={`/offers/add/${id}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                {/* <span
                  onClick={this.onPushClick.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Send Push"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="f-20 icofont icofont-notification text-warning"></i>{' '}
                </span> */}
                <span
                  onClick={this.deleteOffer.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      viewColumns: false,
      print: false,
      download: true,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Offers List</h4>
                    </div>
                  </div>
                  <Link
                    to="/offers/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Offers List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Offers List'}
                          className="table-responsive"
                          data={this.state.offersListData}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OffersList
